import _ from "lodash";
import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("phuket-laguna-village-residences");
const baseAssetVideoUrl = `${baseAssetUrl}/videos`;

const heroShotImg1 = `${baseAssetUrl}/images/gallery/hero-shot/1.jpg`;
const heroShotImg2 = `${baseAssetUrl}/images/gallery/hero-shot/2.jpg`;
const heroShotImg3 = `${baseAssetUrl}/images/gallery/hero-shot/3.jpg`;
const heroShotImg4 = `${baseAssetUrl}/images/gallery/hero-shot/4.jpg`;

const residencesAerialImg1 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/1.jpg`;
const residencesAerialImg2 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/2.jpg`;
const residencesAerialImg3 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/3.jpg`;
const residencesAerialImg4 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/4.jpg`;
const residencesAerialImg5 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/5.jpg`;
const residencesAerialImg6 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/6.jpg`;
const residencesAerialImg7 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/7.jpg`;
const residencesAerialImg8 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/8.jpg`;
const residencesAerialImg9 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/9.jpg`;
const residencesAerialImg10 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/10.jpg`;
const residencesAerialImg11 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/11.jpg`;
const residencesAerialImg12 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/12.jpg`;
const residencesAerialImg13 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/13.jpg`;
const residencesAerialImg14 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/14.jpg`;
const residencesAerialImg15 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/15.jpg`;
const residencesAerialImg16 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/16.jpg`;
const residencesAerialImg17 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/17.jpg`;
const residencesAerialImg18 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/18.jpg`;
const residencesAerialImg19 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/19.jpg`;
const residencesAerialImg20 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/20.jpg`;
const residencesAerialImg21 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/21.jpg`;
const residencesAerialImg22 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/22.jpg`;
const residencesAerialImg23 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/23.jpg`;
const residencesAerialImg24 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/24.jpg`;

const residencesAerial1 = `${baseAssetUrl}/images/gallery/images/residences-aerial/1.jpg`;
const residencesAerial2 = `${baseAssetUrl}/images/gallery/images/residences-aerial/2.jpg`;

const residencesExterior1 = `${baseAssetUrl}/images/gallery/images/residences-exterior/1.jpg`;
const residencesExterior2 = `${baseAssetUrl}/images/gallery/images/residences-exterior/2.jpg`;
const residencesExterior3 = `${baseAssetUrl}/images/gallery/images/residences-exterior/3.jpg`;

const residencesInterior1 = `${baseAssetUrl}/images/gallery/images/residences–interior/1.jpg`;
const residencesInterior2 = `${baseAssetUrl}/images/gallery/images/residences–interior/2.jpg`;
const residencesInterior3 = `${baseAssetUrl}/images/gallery/images/residences–interior/3.jpg`;
const residencesInterior4 = `${baseAssetUrl}/images/gallery/images/residences–interior/4.jpg`;
const residencesInterior5 = `${baseAssetUrl}/images/gallery/images/residences–interior/5.jpg`;
const residencesInterior6 = `${baseAssetUrl}/images/gallery/images/residences–interior/6.jpg`;

const residencesLifestyle1 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/1.jpg`;
const residencesLifestyle2 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/2.jpg`;
const residencesLifestyle3 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/3.jpg`;
const residencesLifestyle4 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/4.jpg`;
const residencesLifestyle5 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/5.jpg`;
const residencesLifestyle6 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/6.jpg`;
const residencesLifestyle7 = `${baseAssetUrl}/images/gallery/images/residences–lifestyle/7.jpg`;

const videos = [
  {
    titleKey: "propertyVideo",
    source: {
      en: `${baseAssetVideoUrl}/Laguna_Village Video_Trilingual_Mar 2022.mp4`,
      cn: `${baseAssetVideoUrl}/Laguna_Village Video_Trilingual_Mar 2022.mp4`,
      ru: `${baseAssetVideoUrl}/Laguna_Village Video_Trilingual_Mar 2022.mp4`,
    },
    text: {
      en: ["PROPERTY VIDEO"],
      cn: ["项目视频"],
      ru: ["ВИДЕО ПРОЕКТА"],
    },
  },
  {
    titleKey: "interiorVideo",
    source: {
      en: `${baseAssetVideoUrl}/LVR8_Interior_video_V4.mp4`,
      cn: `${baseAssetVideoUrl}/LVR8_Interior_video_V4.mp4`,
      ru: `${baseAssetVideoUrl}/LVR8_Interior_video_V4.mp4`,
    },
    text: {
      en: ["INTERIOR VIDEO"],
      cn: ["室内装饰视频"],
      ru: ["ВИДЕО ИНТЕРЬЕРА"],
    },
  },
];

const heroShot = [
  { image: heroShotImg1 },
  { image: heroShotImg2 },
  { image: heroShotImg3 },
  { image: heroShotImg4 },
];

const categories = [
  {
    id: 1,
    name: "All Images",
  },
  {
    id: 2,
    name: "Residences – Aerial",
  },
  {
    id: 3,
    name: "Residences – Exterior",
  },
  {
    id: 4,
    name: "Residences – Interior",
  },
  {
    id: 5,
    name: "Residences – Lifestyle",
  },
  {
    id: 6,
    name: "Destination Lifestyle",
  },
];
const images = [
  {
    categoryId: 2,
    name: "Aerial - 1",
    image: residencesAerial1,
  },
  {
    categoryId: 2,
    name: "Aerial - 2",
    image: residencesAerial2,
  },
  {
    categoryId: 3,
    name: "Exterior - 1",
    image: residencesExterior1,
  },
  {
    categoryId: 3,
    name: "Exterior - 2",
    image: residencesExterior2,
  },
  {
    categoryId: 3,
    name: "Exterior - 3",
    image: residencesExterior3,
  },
  {
    categoryId: 4,
    name: "Master Bedroom",
    image: residencesInterior1,
  },
  {
    categoryId: 4,
    name: "Master Bathroom",
    image: residencesInterior2,
  },
  {
    categoryId: 4,
    name: "Living Room - 1",
    image: residencesInterior3,
  },
  {
    categoryId: 4,
    name: "Living Room - 2",
    image: residencesInterior4,
  },
  {
    categoryId: 4,
    name: "Dining Room",
    image: residencesInterior5,
  },
  {
    categoryId: 4,
    name: "Multipurpose Room",
    image: residencesInterior6,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle1,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle2,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle3,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle4,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle5,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle6,
  },
  {
    categoryId: 5,
    name: "",
    image: residencesLifestyle7,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg1,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg2,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg3,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg4,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg5,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg6,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg7,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg8,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg9,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg10,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg11,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg12,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg13,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg14,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg15,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg16,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg17,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg18,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg19,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg20,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg21,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg22,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg23,
  },
  {
    categoryId: 6,
    name: "",
    image: residencesAerialImg24,
  },
];

const video =
  "https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/vdo/laguna_village_video_trilingual_comp.mp4";
const image360 =
  "https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/location/phuket/laguna-village-residences/assets/360/17.+Virtual+Tour_Aerial/output/LVR-aerial.html";

export default {
  heroShot,
  categories,
  images: _.map(images, (image) => {
    return {
      ...image,
      category: _.find(categories, { id: image.categoryId }),
    };
  }),
  video,
  videos,
  image360,
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaVillageResidences/gallery.js